export default "__VITE_ASSET__443308f3__"